var map = {
	"./ai.svg": "1038",
	"./app_store.svg": "1829",
	"./auth.svg": "644c",
	"./baremetal.svg": "8c94",
	"./bastion_host.svg": "643e",
	"./bill.svg": "eeec",
	"./bill_private.svg": "3875",
	"./business_feature.svg": "cbac",
	"./extdb.svg": "7ae5",
	"./k8s.svg": "808e",
	"./lb.svg": "9564",
	"./monitor.svg": "45b3",
	"./oceanbase.svg": "0dff",
	"./pod.svg": "dc191",
	"./report.svg": "ded9",
	"./suggestion.svg": "1de8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1329";